const constructionServices = [
    {
      id: 1,
      title: "Oil & Gas Facility Construction",
      description:
        "We specialize in building processing plants, refineries, pipelines, and offshore structures designed to withstand extreme conditions while maintaining peak performance."
    },
    {
      id: 2,
      title: "Pipeline Construction & Installation",
      description:
        "Our team delivers end-to-end pipeline solutions, from route planning and material procurement to installation, testing, and commissioning. We ensure environmental compliance and operational safety."
    },
    {
      id: 3,
      title: "Structural Fabrication & Erection",
      description:
        "We design, fabricate, and install steel structures, platforms, and modules for offshore and onshore operations. Our fabrication yards are equipped to handle customized engineering projects of all scales."
    },
    {
      id: 4,
      title: "Civil & Infrastructure Development",
      description:
        "We handle foundation work, road construction, drainage systems, and industrial site development to support oil and gas operations. Our projects align with global standards for durability and sustainability."
    },
    {
      id: 5,
      title: "Modular Construction & Skid Systems",
      description:
        "We provide modular process units and skid-mounted equipment, enabling fast deployment and reducing project timelines. These solutions are cost-effective and adaptable to diverse operational needs."
    },
    {
      id: 6,
      title: "Equipment Installation & Commissioning",
      description:
        "From heavy-duty machinery to delicate instrumentation, we ensure seamless installation, calibration, and integration of equipment critical to oil and gas operations."
    }
  ];
  
  export default constructionServices;
  